import styled from 'styled-components';

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 5px 5px 0px 16px;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  min-width: 100%;
  width: max-content;
  background: ${(props) => (props.isGlass ? 'var(--q3-surface-glass)' : 'var(--q3-surface-default)')};

  ${(props) =>
    props.isGlass &&
    `
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
  `}
  ${(props) =>
    props.rounded &&
    `
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  `}
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    width: 100%;
    background: ${(props) => props.color};
    z-index: 0;
  }
`;

export const Tab = styled.div`
  display: ${(props) => (props.display ?? 'flex')};
  flex-direction: row;
  gap: 10px;
  padding: 10px 20px;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-style: normal;
  font-weight: ${(props) => (props.isActive ? '600' : '500')};
  line-height: 125%;
  color: ${({ isActive, color }) => (isActive ? color : 'var(--q3-neutral-light)')};
  cursor: pointer;
  border-radius: 12px 12px 0px 0px;
  border-top: 2px solid ${(props) => (props.isActive ? props.tabColor : 'transparent')};
  border-right: 2px solid ${(props) => (props.isActive ? props.tabColor : 'transparent')};
  border-left: 2px solid ${(props) => (props.isActive ? props.tabColor : 'transparent')};
  position: relative;
  top: 2px;
  background: ${(props) => (props.isActive ? props.bgColor || 'var(--q3-surface-default)' : 'transparent')};
  transition: all 0.3s ease-in;

  &:hover {
    background: var(--q3-surface-default);
    border-top: 2px solid ${(props) => props.tabColor};
    border-right: 2px solid ${(props) => props.tabColor};
    border-left: 2px solid ${(props) => props.tabColor};
    border-bottom: none;
    top: 2px;
  }
`;

export const SmallTabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  border-bottom: 2px solid ${(props) => props.color};
  min-width: 100%;
  width: max-content;
  padding: 0px 0px 0px 16px;
  background: var(--q3-surface-default);
`;

export const SmallTab = styled.div`
  display: flex;
  flex-direction: row;
  padding: 9px 10px;
  align-items: center;
  font-size: 14px;
  min-width: 56px;
  justify-content: center;
  font-style: normal;
  font-weight: ${(props) => (props.isActive ? '300' : '300')};
  line-height: 100%;
  color: ${({ isActive, color }) => (isActive ? color : 'var(--q3-neutral-light)')};
  cursor: pointer;
  border-radius: 12px 12px 0px 0px;
  border-top: 2px solid ${(props) => (props.isActive ? props.tabColor : 'transparent')};
  border-right: 2px solid ${(props) => (props.isActive ? props.tabColor : 'transparent')};
  border-left: 2px solid ${(props) => (props.isActive ? props.tabColor : 'transparent')};
  position: relative;
  top: 2px;
  background: ${(props) => (props.isActive ? 'var(--q3-surface-default)' : 'transparent')};
  transition: all 0.3s ease-in;

  &:hover {
    background: var(--q3-surface-default);
    border-top: 2px solid ${(props) => props.tabColor};
    border-right: 2px solid ${(props) => props.tabColor};
    border-left: 2px solid ${(props) => props.tabColor};
    border-bottom: none;
    top: 2px;
  }
`;
